<template>
  <div>
    <div class="text-h6 mb-3">{{ $t("Cơ sở") }}</div>
    <v-row>
      <v-col
        cols="12"
        sm="6"
        md="3"
        class="font-weight-bold"
        v-if="branches.length > 1"
      >
        <v-checkbox
          dense
          hide-details
          v-model="allSelected"
          :label="$t('Tất cả')"
          @change="allToggle"
        ></v-checkbox>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="3"
        v-for="branch in branches"
        :key="`br_${branch.id}`"
      >
        <v-checkbox
          dense
          hide-details
          v-model="selected"
          :label="branch.code"
          :value="branch.id"
          multiple
          @change="itemToggle(branch.id)"
        ></v-checkbox>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "PrintPdf",
  data: () => ({
    branches: [],
    selected: [],
    allSelected: false,
  }),
  mounted() {
    this.getBranches();
    this.listenSocket();
  },
  methods: {
    listenSocket() {
      if (!this.isMobileAgent() && this.checkPermission([])) {
        window.socket.on("order_print_contract", (data) => {
          console.log("order_print_contract->data", data);
          const { id_order, id_account, id_branch, print_url } = data;
          console.log(this.selected);
          if (this.selected.includes(id_branch)) {
            // "/order/v1/generate-contract"
            this.downloadPdfServerFilename(print_url, {
              id_order,
              id_account,
            });
          }
        });
      }
    },
    getBranches() {
      const { branches } = window.me;
      this.branches = [...branches];
      if (this.branches.length === 1) {
        this.selected = [...this.branches].map((o) => o.id);
      }
    },
    allToggle() {
      if (!this.allSelected) {
        this.selected = [];
      } else {
        this.selected = [...this.branches].map((o) => o.id);
      }
    },
    itemToggle(val) {
      if (!this.selected.includes(val)) {
        this.allSelected = false;
      }
    },
  },
};
</script>

<style scoped></style>
